import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  title?: ReactNode;
  actions?: ReactNode;
  tight?: boolean;
  interactive?: boolean;
};

export function Card({ title, actions, tight, interactive, className, children, ...rest }: CardProps) {
  return (
    <div className={cx('card', tight && 'card-tight', interactive && 'card-interactive', className)} {...rest}>
      {title || actions ? (
        <div className="card-header">
          {typeof title === 'string' ? <h3>{title}</h3> : title}
          {actions}
        </div>
      ) : null}
      {children}
    </div>
  );
}
